import React from 'react';

import NrgComponent from './../NrgComponent.jsx';
import getIcon from '../../icons/svgController.js';

export default class IconListPanelCol extends NrgComponent {
  render() {
    var icon = this.props.icon;
    const Icon = getIcon(icon.iconName);
    console.log("icon");
    console.log(icon);

    return (
      <div className="item col-xs-8 col-sm-4" data-scroll-item-once>
        <div className="icon-container">
          <div className="row">
            <div className="col-xs-16 col-sm-4 col-md-3">
              {icon.iconName && <Icon viewBox="0 0 60 60"></Icon>}
            </div>
            <div className="col-xs-16 col-sm-12 col-md-13 description-container">
              <div className="text">{icon.description}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

};
